<!--
  PATO doplňková mapová nástrojová nabídka 
-->
<template>

  <div class="d-flex flex-row" v-if="MapLayer_Vukoz_pato_visible">

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="MapPnlGrdItem elevation-5" width="40" min-width="40" min-height="40" color="info" v-bind="attrs"
          v-on="on" @click="MapLayerLegendStaticSet()">
          <v-icon>mdi-map-legend</v-icon>
        </v-btn>
      </template>
      <span class="">Legenda map invazních patogenů dřevin</span>
    </v-tooltip>

    <v-card width="500" color="transparent" flat>
      <v-overflow-btn class="MapPnlGrdItem elevation-5 u_v-autocomplete " :items="Seznam01" v-model="VybSeznam01"
        item-text="Popis" return-object dense hide-details="true" background-color="info" height="40">
        <template v-slot:item="{ item, attrs, on }">
          <v-list-item v-bind="attrs" v-on="on">
            <v-list-item-avatar color="white" tile width="70" height="45">
              <v-img :src="AssetsUrl + '/img/legend/mapa_Vukoz_InvPat_' + item.id + '.png'" />
            </v-list-item-avatar>
            <v-list-item-content style="">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item-title v-bind="attrs" v-on="on" class="text-wrap" v-text="item.Popis"></v-list-item-title>
                </template>
                <span>{{ item.Title }}</span>
              </v-tooltip>

            </v-list-item-content>
          </v-list-item>
        </template>
      </v-overflow-btn>
    </v-card>

    <v-card width="304" color="transparent" flat>
      <v-overflow-btn class="MapPnlGrdItem elevation-5 u_v-autocomplete " :items="VybSeznam01.Seznam"
        v-model="VybSeznam02" item-text="Popis" return-object dense hide-details="true" height="40"
        background-color="info">
        <template v-slot:item="{ item, attrs, on }">
          <v-list-item v-bind="attrs" v-on="on">
            <v-list-item-content>
              <v-list-item-title class="font-italic" v-text="item.Popis" />
              <v-list-item-subtitle v-text="item.PodPopis" />
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-overflow-btn>
    </v-card>



    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="MapPnlGrdItem elevation-5" width="40" min-width="40" min-height="40" color="info" v-bind="attrs"
          v-on="on" @click="VybComp = 'MapPatoInfo'">
          <v-icon>mdi-information-outline</v-icon>
        </v-btn>
      </template>
      <span class="">Informace</span>
    </v-tooltip>





  </div>
</template>

<script>
import AppJson from "../../../assets/MapOt_Pato.json";


export default {

  components: {
    //Teleport: () => import("vue2-teleport")
  },


  props: {
    // Adresa na Assets
    AssetsUrl: null,
    // Mapová služba
    ServiceMap: null,
    // Mapa (Luciad)
    MAP: Object,
    // Měřítko vztažené k rovníku
    MapScale: null,
    // Mapové vrstvy
    MapLegendLayers: null,
    // Viditelnost legendy
    MapLayerLegend_view: null,

    // Seznam  komponent
    CompList: { type: Array },

  },

  data() {
    return {
      // Jestli je nástroj inicializován
      IsInit: false,

      // Seznam vrstev 01
      Seznam01: [],
      // Vybraná vrstva 01
      VybSeznam01: {
        "id": "",
        "Popis": "",
        "Title": "",
        "kod": "",
        "Seznam": []
      },
      // Vybraná vrstva 02
      VybSeznam02: {
        "id": "",
        "Popis": "",
        "PodPopis": "",
        "kod": ""
      },

      // Seznam načtených legend
      PatoStaticLegends: {},

      // Kód zobrazené vrstvy
      VybKodAct: null,

    };
  },



  computed: {
    // Vrstva pato
    MapLayer_Vukoz_pato: function () {
      return this.MapLegendLayers.find((item) => item.id == "Vukoz_pato");
    },
    // Vrstva pato - viditelnost
    MapLayer_Vukoz_pato_visible: function () {
      return this.MapLayer_Vukoz_pato.layer.visible
    },

    // Vrstva pato - id vybrané vrstvy
    VybKod: function () {
      return this.VybSeznam01.kod + "_" + this.VybSeznam02.kod
    },

    // Id legendy vybrané mapy
    VybLegId: function () {
      return "Pato" + this.VybSeznam01.id + "_" + this.VybSeznam02.id
    },

    // Změna vybrané komponenty podle jména
    VybComp: {
      get() {
        return this.$store.getters.GET_sVybComp;
      },
      set(newValue) {
        this.$store.commit("SET_sVybComp", {
          CompName: newValue,
          SlotName: this.CompList.find((item) => item.name == newValue).slot,
        });
      },
    },



  },

  watch: {

    // Změna Seznam01
    VybSeznam01: function (value) {
      this.VybSeznam02 = value.Seznam[0];
    },

    // Změna Seznam02
    VybSeznam02: function () {
      this.ZmenaMapy();
    },

  },

  methods: {



    // Statická mapová legenda - proměnná pro vybranou vrstvu - volá se funkce v nadřazeném objektu
    MapLayerLegendStaticSet: function () {
      this.$emit('MapLayerLegendStaticSet', this.VybLegId, this.VybSeznam01.Popis, this.PatoStaticLegends[this.VybLegId]);
    },


    // Načtení statické legendy
    NactiStaticMapLegend: function (id, Jmeno) {
      this.ServiceMap.MapLegend(Jmeno)
        .then((response) => {
          if (response.data.Dokonceno) {
            this.PatoStaticLegends[id] = response.data.Vypis;
          } else {
            return null;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .then(function () {
          // always executed
        });
    },

    ZmenaMapy: function () {

      if (!this.IsInit && this.VybKodAct == null) {
        // První načtení
        // console.log("První načtení")
        // console.log(this.VybKodAct)
        // console.log(this.VybKod)
        this.VybKodAct = this.VybKod
      }
      else if (this.VybKodAct != this.VybKod) {
        // console.log("ZmenaMapy")
        // console.log(this.VybKodAct)
        // console.log(this.VybKod)

        // Změna legendy, když je zobrazena a došlo ke změně typu
        if (this.MapLayerLegend_view) {
          this.MapLayerLegendStaticSet();
        }

        var vModel = this.MapLayer_Vukoz_pato.layer.model;
        vModel.baseURL = vModel.baseURL.replace(this.VybKodAct, this.VybKod);
        this.MapLayer_Vukoz_pato.label = this.VybSeznam01.Popis;
        this.MapLayer_Vukoz_pato.labelsub = this.VybSeznam02.Popis;

        if (this.MapLayer_Vukoz_pato.legend.image != "img/legend/mapa_Vukoz_InvPat_" + this.VybSeznam01.id + ".png") {
          this.MapLayer_Vukoz_pato.legend.image = "img/legend/mapa_Vukoz_InvPat_" + this.VybSeznam01.id + ".png";
        }

        this.VybKodAct = this.VybKod

      }


    }

  },



  mounted() {
    // První spuštění nástroje
    // console.log("PATO start");
    // console.log(this.MAP);

    // Základní nastavení - 
    this.Seznam01 = AppJson.Seznam;
    // Načtení první vrstvy ze seznamu
    this.VybSeznam01 = this.Seznam01[0];

    // // Načtení legend
    this.Seznam01.forEach((value) => {
      value.Seznam.forEach((value2) => {
        var legId = "Pato" + value.id + "_" + value2.id
        this.NactiStaticMapLegend(legId, legId)
      })
    });

    // Objekt aktivován
    this.MAP.layerTree.whenReady().then(() => { this.IsInit = true; })



  },
};
</script>